import { render, staticRenderFns } from "./promotionList.vue?vue&type=template&id=3235d27b&scoped=true"
import script from "./promotionList.vue?vue&type=script&lang=js"
export * from "./promotionList.vue?vue&type=script&lang=js"
import style0 from "./promotionList.vue?vue&type=style&index=0&id=3235d27b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3235d27b",
  null
  
)

export default component.exports